<script>
  import { router } from '@inertiajs/svelte'
  import Button from '@/components/ui/Button.svelte'
  import Card from '@/components/ui/Card.svelte'
  import Input from '@/components/ui/Input.svelte'
  
  let { token = '', errors = {}, flash = {} } = $props()
  
  let password = $state('')
  let password_confirmation = $state('')
  let isSubmitting = $state(false)
  
  function handleSubmit(e) {
    e.preventDefault()
    isSubmitting = true
    
    router.patch(`/password/reset/${token}`, {
      password,
      password_confirmation
    }, {
      onFinish: () => {
        isSubmitting = false
      }
    })
  }
</script>

<div class="min-h-screen bg-gray-50 dark:bg-dark-primary flex items-center justify-center px-4 py-10">
  <div class="max-w-md w-full">
    <!-- Logo -->
    <div class="text-center mb-8">
      <h1 class="text-h1 text-content mb-2">AX Hub</h1>
    </div>
    
    <!-- Card -->
    <Card padding="lg" bordered>
      {#if flash.alert}
        <div class="mb-6 p-4 bg-error-light border border-error/30 rounded-xl text-error text-body2">
          {flash.alert}
        </div>
      {/if}
      
      <div class="text-center mb-6">
        <div class="flex justify-center mb-4">
          <div class="w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>
        <h2 class="text-h2 text-content mb-2">새 비밀번호 설정</h2>
        <p class="text-body2 text-content-secondary">새로운 비밀번호를 입력해주세요.</p>
      </div>
      
      <form onsubmit={handleSubmit} class="space-y-5">
        <Input
          type="password"
          label="새 비밀번호"
          placeholder="최소 8자 이상"
          bind:value={password}
          required
          error={errors.password}
        />
        
        <Input
          type="password"
          label="비밀번호 확인"
          placeholder="비밀번호 재입력"
          bind:value={password_confirmation}
          required
          error={password && password_confirmation && password !== password_confirmation ? '비밀번호가 일치하지 않습니다' : undefined}
        />
        
        <Button type="submit" fullWidth loading={isSubmitting} loadingLabel="재설정 중..." disabled={!password || password !== password_confirmation}>
          비밀번호 변경
        </Button>
      </form>
      
      <p class="mt-6 text-center">
        <a href="/login" class="text-content-tertiary text-body2 hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">
          ← 로그인으로 돌아가기
        </a>
      </p>
    </Card>
  </div>
</div>
